/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import {
  JobSharedDocListItemDto,
  JobSharedDocNewSetDto,
  JobSharedDocType,
} from './job-shared-docs.dto';

export const JobSharedDocListItemMapper = entity<JobSharedDocListItemDto>({
  sharedDate: date(DateFormat.DateTime),
  docType: enumeration(JobSharedDocType),
});

export const JobSharedDocNewSetMapper = entity<JobSharedDocNewSetDto>({
  type: enumeration(JobSharedDocType),
});
